import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Success from './components/Success';

export default [{
  path: '/',
  component: Login,
  title: '',
}, {
  path: '/forgot-password',
  component: ForgotPassword,
  title: '',
}, {
  path: '/reset-password',
  component: ResetPassword,
  title: '',
}, {
  path: '/success',
  component: Success,
  title: '',
}];
